import { createRef, useState } from 'react';
import { adminAPI } from 'services/admin';

export const useAsyncSelectField = ({
  url,
  optionsMap,
  responseKey,
  loadOptionsOnMenuOpen,
  fetchOptionsOnFirstOpen,
}) => {
  const selectRef = createRef();
  const searchRef = createRef();
  const [options, setOptions] = useState();

  const defaultLoadOptions = async (search, prevOptions) => {
    // use localOptions after first fetch
    if (fetchOptionsOnFirstOpen && options) {
      return {
        options: options.filter(({ label }) =>
          label.toLowerCase().includes(search?.toLowerCase())
        ),
        hasMore: false,
      };
    }

    // Search only for text length >= 3
    if (!loadOptionsOnMenuOpen && search.length < 3) {
      return {
        options: options || [],
        hasMore: false,
      };
    }
    const newOffset = prevOptions.length;
    const requestUrl = url
      .replace('#name', search)
      .replace('#key', search)
      .replace('#offset', newOffset);

    try {
      if (fetchOptionsOnFirstOpen && searchRef.current === 'loading')
        return { options: [] }; //prevent multiple requests

      searchRef.current = 'loading';
      const response = await adminAPI.get(requestUrl);
      const data = response[responseKey];
      const total = response.totalItemsCountFiltered;

      const optionsResult = optionsMap
        ? optionsMap(data)
        : data.map(data => ({
            label: data.name || data.key, // Posíveis labels
            value: data.id || data.userId, // Possíveis chaves para id
            role: data?.role, // Para usuários
            deleted: data?.deleted ?? false,
          }));

      const hasMoreItemsToFetch = newOffset + optionsResult.length < total;

      if (fetchOptionsOnFirstOpen && !hasMoreItemsToFetch) {
        setOptions([...prevOptions, ...optionsResult]);
      }

      return {
        options: optionsResult,
        hasMore: hasMoreItemsToFetch,
      };
    } catch (error) {
      return { options: [], hasMore: false };
    }
  };

  return { defaultLoadOptions, selectRef };
};
